<div class="toolbar d-flex align-items-center justify-content-center">

  <!-- Toggle Icons -->
  <div class="icon-wrapper d-flex flex-column align-items-center">
    <!-- Expand -->
    <svg *ngIf="!panelOpenState"
          (click)="expandPanel($event)"
         xmlns="http://www.w3.org/2000/svg"
         height="30"
         width="30"
         viewBox="0 -960 960 960"
         class="toggle-icon">
      <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
    </svg>

    <!-- Collapse -->
    <svg *ngIf="panelOpenState"
          (click)="collapsePanel($event)"
         xmlns="http://www.w3.org/2000/svg"
         height="30"
         width="30"
         viewBox="0 -960 960 960"
         class="toggle-icon">
      <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/>
    </svg>
  </div>

  <!-- Search -->
  <div class="flex-grow-1">
    <div class="input-group search_group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="searchText"
        (keyup.enter)="triggerSearch()"
          (click)="$event.stopPropagation()"
       (focus)="$event.stopPropagation()"
        placeholder="Global Search">

      <div class="input-group-append">
        <button
          type="button"
          (click)="triggerSearch()"
          class="button white-button">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Expansion Panel -->
 <div #expansionWrapper class="expansion-panel">
<mat-expansion-panel [expanded]="panelOpenState">
 <form [formGroup]="form">
<div>

  <div
    class="d-flex align-items-center gap-3 p-2"
    *ngFor="let filter of filterList">

    <!-- Label -->
    <label class="fw-500 mb-0 min-label-width">
      {{ filter.label }}
    </label>

    <!-- Dropdown -->
    <ng-select
      class="flex-grow-1"
      [items]="filter.options"
      [formControlName]="filter.controlName"
      placeholder="{{ filter.placeholder }}"
      [clearable]="false"
      [searchable]="true"
      [multiple]="true"
      [closeOnSelect]="false"
       appendTo="body"
       (change)="onSelectionChange(filter.controlName)">
              <ng-template ng-header-tmp>
               <div>
                   <button class="btn btn-link"
                       (click)="onSelectAll(filter.controlName)">Select
                       All</button>
                   <button class="btn btn-link"
                       (click)="onClearAll(filter.controlName)">Clear
                       All</button>
               </div>
             </ng-template>
             <ng-template ng-option-tmp let-item="item" let-item$="item$"
                 let-index="index">
                 <input id="item-{{index}}" type="checkbox"
                     [checked]="item$.selected" />
                 <!-- {{item.label}} -->
                  <span class="dropdown-text" [title]="item">{{ item }}</span>
            </ng-template>
           <ng-template ng-multi-label-tmp let-items="items">
   
  <!-- Single selection → show label -->
  <div *ngIf="selectedCount[filter.controlName] === 1" class="ng-values-list">
    <div class="ng-value">
      <span class="ng-value-label">{{ items[0] }}</span>
      <span class="ng-value-icon right"
            (click)="onClearAll(filter.controlName)">×</span>
    </div>
  </div>

  <!-- Multiple selection → show summary -->
  <div *ngIf="selectedCount[filter.controlName] > 1" class="ng-summary-list">
    <div class="ng-value">
      <span class="ng-value-label">
        {{ selectedCount[filter.controlName] }} Selected
      </span>
          <span class="ng-value-icon right"
          (click)="onClearAll(filter.controlName)">×</span>
    </div>
  </div>
</ng-template>

    </ng-select>

  </div>

</div>
 <div class="col-md-12 text-center"> 
      <input type="submit" value="Search" (click)="onSearchClick()" class="submit-button" />
      <input type="button" value="Reset" (click)="resetForm()" class="submit-button" />
 </div>
</form>

</mat-expansion-panel>
 </div>